import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

const getPosition = () =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });

class Geolocation extends Component {
  constructor() {
    super();

    this.state = { isFetching: false, coords: undefined, error: false };
    this.geolocationTest = "geolocation" in navigator;
  }

  locate = () => {
    this.setState({ isFetching: true });

    getPosition()
      .then(this.handleLocation)
      .catch(this.handleError);
  };

  handleLocation = position => {
    const { onComplete } = this.props;

    this.setState(
      {
        isFetching: false,
        coords: position.coords
      },
      () => {
        if (onComplete) {
          onComplete(position.coords);
        }
      }
    );
  };

  handleError = error => {
    const errors = {
      1: "Locatie delen van je browser staat uit. Zet het aan in je instellingen of zoek hierboven jouw gemeente",
      default: "Er ging iets fout met het ophalen van jouw locatie..."
    };

    const msg = errors[error.code] || errors.default;

    this.setState(
      {
        isFetching: false,
        coords: undefined,
        error: msg
      },
      () => {
        if (this.props.onError) {
          this.props.onError(msg);
        }
      }
    );
  };

  render() {
    const { renderLoading, renderTrigger, renderError } = this.props;
    const { coords, isFetching, error } = this.state;

    if (!this.geolocationTest || coords !== undefined) {
      return false;
    }

    return (
      <Fragment>
        {isFetching && renderLoading}
        {!isFetching && !error && renderTrigger(this.locate)}
        {error && renderError && renderError(error)}
      </Fragment>
    );
  }
}

Geolocation.propTypes = {
  renderLoading: PropTypes.element.isRequired,
  renderTrigger: PropTypes.func.isRequired,
  renderError: PropTypes.func,
  onError: PropTypes.func,
  onComplete: PropTypes.func
};

export default Geolocation;



// WEBPACK FOOTER //
// ./src/components/Geolocation/index.js